import { useState } from "react";
import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import { UserSolidV6 } from "@shared/v2/Icomoon";
import BaseEvent from "./BaseEvent";
import { isServiceUpdater } from "./helpers/updaterAttribution";

const TimelineTaggingEvent = ({ event, event: { timeline_fields: timelineFields } }) => {
  const [showModal, setShowModal] = useState(false);
  const action = event.event_type === "tagging_destroyed" ? "deleted" : "added";

  const content = <span className={`tag-${action}`}>{timelineFields.tag}</span>;
  const summary = isServiceUpdater(timelineFields) ? (
    <>
      Tag automatically {action} by{" "}
      <span className="tw-font-semibold">{timelineFields.updater_name}</span>:
    </>
  ) : (
    <>
      <span className="tw-font-semibold">{timelineFields.updater_name} </span>
      {action} a tag:
    </>
  );

  return (
    <BaseEvent
      icon={<UserSolidV6 />}
      title={<div>{summary}</div>}
      interactedAt={event.interacted_at_absolute}
      onClick={() => setShowModal(true)}
    >
      {content}
      <Modal
        dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
        contentClassName="tw-max-w-[480px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header title="Tag" closeButton />
        <Modal.Body>
          {summary} {content}
        </Modal.Body>
      </Modal>
    </BaseEvent>
  );
};

TimelineTaggingEvent.propTypes = {
  event: PropTypes.shape().isRequired,
};

export default TimelineTaggingEvent;
